import { SpinnerContainer, SpinnerOverlay } from "./spinner.style";

const Spinner = () => {
  return (
    <SpinnerOverlay>
      <SpinnerContainer />
    </SpinnerOverlay>
  );
};

export default Spinner;
